<template>
    <!-- 6 行 subgrid：与 .plan-content / .owl-stage 共享行高；portal 不参与网格 -->
    <div
        :class="['lock-plan-card', 'plan-item-col', isBasic ? 'isBasic' : '', isRecommended || isBasic ? 'active' : '']"
        ref="container"
    >
        <div class="card-row card-row-badge">
            <div class="device-group">
                <span v-if="currentPlanSeries.category==='cloud_data_plan'">{{$t('without_cloud_storage')}}</span>
                <span v-else>{{$t('with_cloud_storage')}}</span>
            </div>
        </div>
        <div class="card-row card-row-title">
            <h4 class="pc">
                <span class="title-label" :style="{'background-color': `${color}`}"></span>
                <span>{{ currentPlanSeries.i18n.name }}</span>
                <span v-if="isCurrentSubscriptionPlan" class="current-plan">
                    {{ !isMobile? $t('current_plan'): $t('current_plan_abbr') }}
                </span>
            </h4>
        </div>
        <div class="card-row card-row-selectors" ref="selectors">
            <reo-select
                v-if="currentPlanSeries.category!=='cloud_data_plan'"
                ref="cycleFrequency"
                class="plan-select"
                :widthOut='selectorStyle.widthOut'
                :heightOut='selectorStyle.heightOut'
                :widthIn='selectorStyle.widthIn'
                :heightIn='selectorStyle.heightIn'
                :selectMarginLeft='selectorStyle.selectMarginLeft'
                :triangleRight='selectorStyle.triangleRight'
                :fontSizeIn ='selectorStyle.fontSizeIn'
                :fontSizeOut='selectorStyle.fontSizeOut'
                :maxHeight ='selectorStyle.maxHeight'
                :optionListMinWidth="selectorStyle.optionListMinWidth"
                :options="videoRetentionDayOptions"
                :defaultSelected="defaultVideoLifeTime"
                @input="handleVideoLifeTimeChange"
            >
            </reo-select>
            <reo-select
                ref="deviceQuantity"
                class="plan-select"
                :widthOut='selectorStyle.widthOut'
                :heightOut='selectorStyle.heightOut'
                :widthIn='selectorStyle.widthIn'
                :heightIn='selectorStyle.heightIn'
                :selectMarginLeft='selectorStyle.selectMarginLeft'
                :triangleRight='selectorStyle.triangleRight'
                :fontSizeIn ='selectorStyle.fontSizeIn'
                :fontSizeOut='selectorStyle.fontSizeOut'
                :maxHeight ='selectorStyle.maxHeight'
                :optionListMinWidth="selectorStyle.optionListMinWidth"
                :options="dataPackageSizeOptions"
                :defaultSelected="defaultCurrentPlanProductIndex"
                v-model="currentPlanProductIndex"
            >
            </reo-select>
        </div>
        <div class="card-row card-row-price">
            <p class="short-cycle">
                <template v-if="!free">
                    <span class="currency">{{ currentPlan.currency }}</span>
                    <span class="price">{{ $n( monthlySalePrice, 'fixed2') }}</span>
                    <span class="cycle">/{{ $t('month') }}</span>
                </template>
                <template v-else>
                    <span class="currency">{{ isBasic ? $t( 'homepage.basic_free_des' ) : $t( 'plan.free' ) }}</span>
                </template>
                <span
                    :class="['long-cycle']"
                    v-if="monthlyRegularPrice > monthlySalePrice">
                    <span class="currency">{{ currentPlan.currency }}</span>
                    <span class="price">{{ $n( monthlyRegularPrice, 'fixed2') }}</span>
                    <span class="cycle">/{{ $t('month') }}</span>
                </span>
                <span class="bill" v-if="!isMonthlyPlan">
                    <br />
                    {{ $t('plan.bill',{
                        cycle: $tc(`cycle_unit.${currentDuration.unit}`, currentDuration.amount, {
                            count: currentDuration.amount
                        })}) }}
                </span>
            </p>
        </div>
        <div class="card-row card-row-cta">
            <div class="plan-notice-box">
                <reo-common-button
                    class='subscription-button'
                    @click="goSubscription"
                    ga-label="Subscribe to Reolink Cloud"
                    :label="subscribeButtonLabel"
                    :disabled="isOtherRegion"
                />
                <p class="plan-discount" v-if="planDiscount">{{ planDiscount }}</p>
                <rich-text
                    class="plan-notice"
                    v-if='currentPlan.i18n.description'
                    :html="currentPlan.i18n.description"
                    :disabled="isOtherRegion"
                    @click.stop="handlePlanNoticeRichTextSubscribe"
                />
                <rich-text
                    class="plan-notice"
                    v-if='currentPlanPromotionText'
                    :html="currentPlanPromotionText"
                    :disabled="isOtherRegion"
                    @click.stop="handlePlanNoticeRichTextSubscribe"
                />
            </div>
        </div>
        <div class="card-row card-row-features">
            <ul class="bottom-content">
                <li>
                    <i class="icon-check"></i>
                    <span v-html="filterHelper('planFlow', currentPlan)"></span>
                </li>
                <li v-if="currentPlanSeries.category!=='cloud_data_plan'">
                    <i class="icon-check"></i>
                    <span class="plan-feature-number" v-html="filterHelper('planHistory', currentPlan)"></span>
                </li>
                <li v-if="filterHelper('planRichNotification', currentPlan)!==''">
                    <i class="icon-check"></i>
                    <span v-html="filterHelper('planRichNotification', currentPlan)"></span>
                    <reo-tip>
                        <span>{{$t('homepage.richNotification')}}</span>
                    </reo-tip>
                </li>
                <template v-if="showAiInfo">
                    <template v-for="feature in config.aiFeatures">
                        <li v-if="currentPlan.style[`cloud_ai.${feature}`]" :key="feature">
                            <i class="icon-check"></i>
                            <span>
                                <span>{{ $t(`cloud_ai.${feature}`) }}</span>
                            </span>
                        </li>
                    </template>
                </template>
            </ul>
        </div>
        <!-- display:none：不占 subgrid 行；内容由 portal 挂到 body -->
        <div class="portal-host" aria-hidden="true">
            <portal to="body">
                <available-devices-dialog
                    v-if="showAvailableDevices"
                    @cancel="showAvailableDevices = false"
                    :cloud-product-lists="cloudProductLists"
                    :supported-device-list="deviceGroupInfo.models"
                    :device-group-des='deviceGroupInfo.des'
                />
            </portal>
        </div>
    </div>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue';
import ReoTip from '@/components/promptMessage.vue';
import ReoSelect from '@/basic/ReoSelect.vue';
import { config } from 'CONFIG';
import { timeResolvePDT } from '@/common/js/date';
import { ISelectorStyle, IReoSelectOption, IPromotionItem, IPlan, IPlanSeries } from '@reolink-cloud/interface';
import { getPlanDataSizeStr, getPlanPromotionText } from '@/utils/business';
import { IDeviceGroupWithPlans, IDuration } from '@/view/reolink/homepage/lib/types';
import { ITemporalObj } from '@/interface/api/products/plan';
import { CustomerFilters } from '@/interface';
import AvailableDevicesDialog from '@/components/Dialogs/AvailableDevicesDialog.vue';
import { Portal } from 'portal-vue';
import { getPlansByDuration } from '@/view/reolink/homepage/lib/utils';
import { ISubscriptionWithPlanInfo } from '@/components/PlanSubscribeSection/lib/types';
import { planFlow } from '@/filter';

export default Vue.extend({

    components: {

        ReoSelect,
        ReoTip,
        AvailableDevicesDialog,
        Portal

    },
    props: {

        deviceGroupInfo: Object as PropType<IDeviceGroupWithPlans>,
        subscription: Object as PropType<ISubscriptionWithPlanInfo | null>,
        listIndex: Number,
        activeItem: Number,
        promotions: Array as PropType<IPromotionItem[]>,
        showAiInfo: Boolean,
        currentDuration: Object as PropType<IDuration>,
        cloudProductLists: Object,
        isUpdatePlan: Boolean,
        isOtherRegion: Boolean,
        displayOnly: Boolean

    },
    data () {

        return {

            currentVideoLifeTime: 0,
            defaultVideoLifeTime: 0,
            currentPlanProductIndex: 0,
            defaultCurrentPlanProductIndex: 0,
            config,
            dialogStack: [] as any[],
            showAvailableDevices: false,
            optionListWidth: 3.64,
            resizeObserver: null as ResizeObserver | null

        };

    },
    computed: {

        isMobile(): boolean {

            return this.$store.getters.isMobile;

        },

        plansInCurrentDuration(): IPlan[] {

            return getPlansByDuration( this.deviceGroupInfo.planList, this.currentDuration );

        },

        currentPlan (): IPlan {

            return this.plansInCurrentDuration[this.currentPlanProductIndex];

        },

        currentPlanSeries(): IPlanSeries {

            return this.cloudProductLists.planSeries[this.currentPlan.seriesKey];

        },

        isBasic (): boolean {

            return this.currentPlan.title === config.basic_plan_title;

        },

        isRecommended (): boolean {

            return this.currentPlan.style[ 'plan.recommended' ];

        },

        videoRetentionDayOptions (): IReoSelectOption[] {

            let arr = this.plansInCurrentDuration.map(( product ) => {

                return product.style['cloud_storage.video_lifetime'];

            });

            return [...new Set( arr )].map(( maxStorageDay ) => {

                return {

                    value: maxStorageDay,
                    label: this.$t( 'plan.maxHistory', {
                        history: maxStorageDay
                    }).toString().replace( '<span>', '' ).replace( '</span>', '' ),
                    id: maxStorageDay

                } as IReoSelectOption;

            });

        },

        dataPackageSizeOptions (): IReoSelectOption[] {

            let arr: IReoSelectOption[] = [];

            for ( const [index, product] of this.plansInCurrentDuration.entries()) {

                if ( product.style['cloud_storage.video_lifetime'] === this.currentVideoLifeTime ) {

                    arr.push({
                        value: index,
                        label: getPlanDataSizeStr( product, this.$i18n ),
                        id: index
                    });

                }

            }

            return arr;

        },

        color (): string {

            return this.currentPlan.style[ 'plan.display_color' ];

        },

        userStatus (): string {

            return this.$store.state.user.status;

        },

        unit (): string {

            let interval = this.currentPlan.duration;
            return this.$tc( `cycle_unit.${interval.unit}`, interval.amount, {

                count: interval.amount

            });

        },

        free (): boolean {

            return Number( this.currentPlan.pricing.salePrice ) === 0;

        },

        limitedDay () {

            let limitedDay = this.currentPlan[ 'style' ][ 'virtual_product.effect_ttl' ];
            if ( !limitedDay ) {

                return {};

            }
            let date = timeResolvePDT( limitedDay );
            return {

                year: date.year,
                monthAbbr: date.monthAbbr,
                monthlong: date.monthLong,
                dateOfMonthOrder: date.dateOfMonthOrder,
                dateOfMonth: date.dateOfMonth

            };

        },

        planDiscount (): string {

            let currentPlan = this.currentPlan;
            let { regularPrice: rawRegularPrice, salePrice: rawSalePrice } = currentPlan.pricing;
            const regularPrice = Number( rawRegularPrice );
            const salePrice = Number( rawSalePrice );
            if ( salePrice === 0 || !regularPrice || regularPrice === 0 || regularPrice <= salePrice ) {

                return '';

            }
            let discount = 100 - ( salePrice * 100 / regularPrice );
            return discount < 1 ? '' : this.$t( 'plan.discount', { discount: discount.toFixed( 0 ) }) as string;

        },

        selectorStyle (): ISelectorStyle {

            return !this.isMobile ? {
                widthOut: -1,
                heightOut: 0.48,
                widthIn: -1,
                heightIn: 0.48,
                selectMarginLeft: 0.16,
                triangleRight: 0.16,
                maxHeight: 3.08,
                fontSizeIn: 0.14,
                fontSizeOut: 0.16,
                optionListMinWidth: this.optionListWidth
            } : {
                widthOut: -1,
                heightOut: 0.48,
                widthIn: -1,
                heightIn: 0.4,
                selectMarginLeft: 0.16,
                triangleRight: 0.16,
                maxHeight: 4.8,
                fontSizeIn: 0.16,
                fontSizeOut: 0.14
            };

        },
        currentPlanPromotionText (): string | undefined {

            return getPlanPromotionText( this.promotions, this.currentPlan );

        },

        /**
         * 将当前套餐的售价转换为按月计算的价格
         */
        monthlySalePrice (): number {

            const salePrice = Number( this.currentPlan.pricing?.salePrice || 0 );
            const duration = this.currentPlan.duration;

            return this.convertToMonthlyPrice( salePrice, duration );

        },

        /**
         * 将当前套餐的原价转换为按月计算的价格
         */
        monthlyRegularPrice (): number {

            const regularPrice = Number( this.currentPlan.pricing?.regularPrice || 0 );
            const duration = this.currentPlan.duration;

            return this.convertToMonthlyPrice( regularPrice, duration );

        },

        isMonthlyPlan(): boolean {

            return this.currentDuration.unit === 'month' && this.currentDuration.amount === 1;

        },

        isCurrentSubscriptionPlan(): boolean {

            return this.subscription?.plan.id === this.currentPlan.id;

        },

        subscribeButtonLabel(): string {

            if ( this.displayOnly ) {

                if ( this.userStatus === 'logined' ) {

                    return this.$t( 'subscribe.select_device_to_buy' ).toString();

                }
                return this.$t( 'subscribe.login_and_select_device' ).toString();

            } else if ( this.isOtherRegion ) {

                return this.$t( 'subscribe.not_available' ).toString();

            } else {

                return this.isUpdatePlan ? this.$t( 'cloud.noVerify.choose' ).toString() : this.$t( 'cloud.noVerify.subscribe' ).toString();

            }

        },

    },
    mounted() {

        const selectors = this.$refs.selectors as HTMLElement;
        if ( selectors ) {

            this.resizeObserver = new ResizeObserver(() => {

                this.optionListWidth = selectors.clientWidth / 100;

            });
            this.resizeObserver.observe( selectors );

        }

    },
    beforeDestroy() {

        if ( this.resizeObserver ) {

            this.resizeObserver.disconnect();

        }

    },
    methods: {
        planFlow,

        /**
         * 将价格根据周期转换为按月计算
         */
        convertToMonthlyPrice ( price: number, duration: ITemporalObj ): number {

            if ( price === 0 ) return 0;

            const { amount, unit } = duration;

            switch ( unit ) {

                case 'day':
                    // 天转月：价格 * 30.44 / 天数 (30.44是平均每月天数)
                    return ( price * 30.44 ) / amount;
                case 'week':
                    // 周转月：价格 * 4.345 / 周数 (4.345是平均每月周数)
                    return ( price * 4.345 ) / amount;
                case 'month':
                    // 月：价格 / 月数
                    return price / amount;
                case 'year':
                    // 年转月：价格 / (年数 * 12)
                    return price / ( amount * 12 );
                default:
                    return price;

            }

        },

        toggle (): void {

            let container: any = $( this.$refs.container! );
            container.toggleClass( 'active' );
            container.find( '.content-wrap' ).slideToggle( 500 );
            if ( container.hasClass( 'active' )) {

                this.$emit( 'changeActive', this.listIndex );

            }

        },
        dialogMounted ( ref ): void {

            if ( this.dialogStack.length === 0 ) {

                $( $( 'html' )[0] ).toggleClass( 'dialogActivated' );

            }
            this.dialogStack.push( ref );

        },
        dialogDestroyed ( ): void {

            this.dialogStack.pop();
            if ( this.dialogStack.length === 0 ) {

                $( $( 'html' )[0] ).toggleClass( 'dialogActivated' );

            }

        },
        filterHelper( name: keyof CustomerFilters, data: any ): string {

            return ( this.$options.filters as unknown as CustomerFilters )[name].call( this, data );

        },
        goSubscription( fromPromotionRichText = false ): void {

            if ( this.displayOnly ) {

                this.$router.push({
                    path: '/user/my-devices/',
                    query: { tab: 'sim' }
                }).catch( console.error );
                return;

            }

            this.$emit( 'goSubscription', {
                plan: this.currentPlan,
                isCurrentSubscriptionPlan: this.isCurrentSubscriptionPlan,
                fromPromotionRichText
            });

        },
        /** 套餐说明 / 营销富文本内 <apply-button />，购物车侧按促销 usageLimitToItems 预填 */
        handlePlanNoticeRichTextSubscribe(): void {

            if ( this.isOtherRegion ) return;
            this.goSubscription( true );

        },
        setDefaultSelected(): void {

            const recommendPlans = this.plansInCurrentDuration.filter( plan => plan.style['plan.recommended'] ).sort(
                ( a, b ) => Number( a.style['plan.sort'] ) - Number( b.style['plan.sort'] )
            );
            const defaultPlan = recommendPlans[0] ?? this.plansInCurrentDuration[0];
            this.currentVideoLifeTime = defaultPlan.style['cloud_storage.video_lifetime'] ?? 1;
            this.currentPlanProductIndex = this.plansInCurrentDuration.findIndex( plan => plan.id === defaultPlan.id );
            this.defaultVideoLifeTime = defaultPlan.style['cloud_storage.video_lifetime'] ?? 1;
            this.defaultCurrentPlanProductIndex = this.plansInCurrentDuration.findIndex( plan => plan.id === defaultPlan.id );

        },
        handleVideoLifeTimeChange( val: number ): void {

            if ( val === this.currentVideoLifeTime ) {

                return;
            
            }
            this.currentVideoLifeTime = val;
            const currentPlans = this.plansInCurrentDuration.filter( plan => plan.style['cloud_storage.video_lifetime'] === val );
            const recommendPlans = currentPlans.filter( plan => plan.style['plan.recommended'] ).sort(
                ( a, b ) => Number( a.style['plan.sort'] ) - Number( b.style['plan.sort'] )
            );
            const selectedPlan = recommendPlans[0] ?? currentPlans[0];
            const selectedProductIndex = this.plansInCurrentDuration.findIndex( plan => plan.id === selectedPlan.id );
            this.defaultCurrentPlanProductIndex = selectedProductIndex;
            this.currentPlanProductIndex = selectedProductIndex;

        },

    },
    watch: {

        activeItem ( activeItem ) {

            if ( activeItem !== this.listIndex ) {

                let container: any = $( this.$refs.container! );
                container.removeClass( 'active' );
                container.find( '.content-wrap' ).slideUp( 500 );

            }

        },

        videoRetentionDayOptions: {

            handler ( ) {

                this.setDefaultSelected();

            },
            immediate: true

        },

        currentPlan() {

            this.$emit( 'updateCurrentPlan' );

        }

    }

});
</script>

<style lang="less">
.plan-item-col .bottom-content li>span>span{
    font-weight: 600;
}
.plan-feature-number span{
    font-weight: 600;
}
</style>

<style scoped lang="less">
.lock-plan-card{
    /* 与 .plan-content / .owl-stage 共享 6 行（subgrid） */
    display: grid;
    grid-template-rows: subgrid;
    // 勿写 1 / span 6：Less 可能把 / 当除法
    grid-row: span 6;
    grid-template-columns: minmax(0, 1fr);
    border-radius: @border-radius-level-2;
    background-color: @bg_02;
    box-sizing: border-box;
    max-width: 484px;
    width: 100%;
    text-align: left;
    padding: 0 40px 32px;
    position: relative;
    overflow: hidden;
    border: 1px solid @b_2;
    min-width: 0;
    .mobile({
        max-width: 100%;
        padding: 0 20px 20px;
    });
}

.card-row{
    min-width: 0;
}

.card-row-badge{
    align-self: start;
}

.card-row-title{
    padding-top: 36px;
    .mobile({
        padding-top: 16px;
    });
}

.card-row-selectors{
    padding-top: 24px;
}

.card-row-price{
    padding-top: 24px;
}

.card-row-cta{
    padding-top: 24px;
}

.card-row-features{
    padding-bottom: 0;
}

.portal-host{
    display: none;
}

h4 {
    font-weight: 600;
    margin: 0;
    &.pc{
        font-size: 24px;
        .mobile({
            font-size: 22px;
        });
    }
    span {
        vertical-align: middle;
    }
}

.plan-notice-box{
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    position: relative;
}

.plan-discount{
    font-size: 14px;
    line-height: 1.2;
    position: absolute;
    top: -10px;
    right: -10px;
    color: @white;
    padding: 6px 12px;
    border-radius: 20px 20px 20px 2px;
    background-color: #FF894A;
}

.plan-notice{
    margin-top: 16px;
    width: 100%;
    font-size: 14px;
    color: #E74330;
    min-height: 20px;
}

.plan-select{
    position: relative;
    & + .plan-select {
        margin-top: 0.16rem;
    }
}

.short-cycle{
    margin: 0;
    .currency{
        font-size: 28px;
        font-weight: 600;
        .mobile({
            font-size: 24px;
        })
    }
    .price{
        font-weight: 600;
        font-size: 28px;
        .mobile({
            font-size: 24px;
        })
    }
    .cycle{
        font-size: 16px;
        color: @font_secondary;
    }
}

.long-cycle{
    text-decoration: line-through;
    color: @font_secondary;
    margin-left: 12px;
    .text{
        font-size: 14px;
    }
    .currency{
        font-weight: 400;
        .text();
    }
    .price{
        font-weight: 500;
        .text();
    }
    .cycle{
        .text();
    }
}

.bottom-content{
    padding-top: 24px;
    border-top: 1px solid @line;
    margin: 24px 0 0;
    text-align: left;
    i{
        font-size: 20px;
        vertical-align: middle;
        margin-right: 8px;
    }
    span{
        vertical-align: middle;
        font-size: 14px;
    }
    li+li{
        margin-top: 12px;
    }
    .tooltip{
        display: inline-block;
        vertical-align: middle;
    }
}

.title-label{
    display: inline-block;
    border-radius: 100%;
    width: 10px;
    height: 10px;
    margin-right: 0.1rem;
}

.device-group{
    background-color: @bg_01;
    border-radius: @border-radius-level-2 0;
    padding: 8px 24px;
    font-size: 14px;
    max-width: 80%;
    width: fit-content;
    margin: 0;
    margin-left: -40px;
    .mobile({
        margin-left: -20px;
    });
    span{
        font-weight: 500;
    }
}

.bill{
    padding-left: 4px;
    color: @font_secondary;
}

.current-plan{
    display: inline-block;
    padding: 0 16px;
    margin-left: 4px;
    background-color: #FFAC3E;
    color: #fff;
    border-radius: 0.08rem;
    font-weight: 500;
}

</style>
